'use strict';

/**
 * @classname TextAreaOpen
 * @classdesc LPのテキストエリアを広げるボタン
 */
export default class TextAreaOpen {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {instance} controller - controller オブジェクト
	 */
	constructor($e) {
		console.log('TextAreaOpen.constructor');
		this._$e = $e;
		this._$target = $(`#${$e.attr('data-target')}`)
		this._maxHeight = $e.attr('data-max-height') || 65;
		this._$target.css('max-height', `${this._maxHeight}px`);
		$e.on('click', (e) => this.onClick(e));
	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof TextAreaOpen
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('TextAreaOpen.onClick');
		e.preventDefault()

		const self = this;

		//テキストエリアが閉じている状態でクリックされたら
		if (!this._$e.hasClass('open')) {
			this._$target.removeClass('block--line-clamp')
			this._$target.animate({ 
				'max-height': '10000px'
			}, 300, function() {
				self._$e.addClass('open');
				self._$e.find('.text').html('詳細を閉じる')
			});
		}else{
			this._$target.animate({ 
				'max-height': `${self._maxHeight}px`
			}, 300, function() {
				$(this).addClass('block--line-clamp');
				self._$e.removeClass('open');
				self._$e.find('.text').html('詳細を見る')
			});
		}
	};
};